// Centralized data for Surgical Sets so you can easily add more sets
export const surgicalSets = [
  {
    id: 'abdominoplasty-set',
    name: 'Abdominoplasty Set',
    image: '/ss/Abdominoplasty Set.jpg',
    description: 'Complete instrument set for abdominoplasty procedures.',
    items: [
      'Scalpel blades #15',
      'Scalpel blades #21',
      'Scalpel handle, #7',
      'Scalpel handle, #4l long',
      'Ragnell kilner scissors, 13cm, curved – flattened at distal end',
      'Adson delicate tissue and suture forceps, 15cm, 1×2 teeth',
      'Adson brown delicate tissue forceps, 12cm, 9×9 teeth, straight – atraumatic',
      'Potts smith tissue forceps, 20cm, 1×2 teeth – delicate',
      'Allis Tissue Forcep 5X6 teeth, 16cm',
      'Wright derf t.c. needle holder, 12.5cm, serrated',
      'Mayo hegar t.c. needle holder, 15cm',
      'Mayo hegar t.c. needle holder, 23cm',
      'Backhaus towel clamp, 8.5cm',
      'Joseph skin hook, double prong, sharp, 16cm, 10mm wide',
      'Stevens Supercut Tenotomy Scissors, 10.5cm, Curved, Blunt – Delicate',
      'Supercut mayo scissors, 14cm, straight',
      'Supercut gorney scissors, 23cm, curved',
      'Supercut gorney freeman scissors, 23cm, curved “gold tip”',
      'Supercut scissors, 20cm, curved, slight bevel on shank, “gold tip”',
      'Supercut scissors, 20cm, curved, strong bevel on shank',
      'Farabeuf baby retractors, 12cm, double ended, set of 2',
      'Israel retractor, 25cm, 6 blunt prongs, 60mm wide x 50mm deep',
      'Saldanha solz abdominal retractor, 37cm',
    ],
  },
  {
    id: 'abdominoplasty-set-tummy-tuck',
    name: 'Abdominoplasty Set (Tummy Tuck)',
    image: '/ss/Abdominoplasty-Set-Tummy-Tuck.jpg',
    description: 'Comprehensive instrument set for abdominoplasty (tummy tuck).',
    items: [
      'Ruler Stainless',
      'Knife Handle No #3',
      'Halsted Mosquito Forceps Curved 12.5cm',
      'Mayo-Hegar Tc Needle Holder 16cm',
      'Webster Tc Needle Holder Plain Tip 12.5cm',
      'Adson Tissue Forceps 1×2 teeth With Cross Serrated 12cm',
      'Joseph Hook Sharp Double Prong 10mm',
      'Mayo Scissors Straight 14cm Tc',
      'Gorney Freeman Scissors TC Curved 23cm',
      'Metzenbaum Scissors SuperCut Curved 15cm',
      'Stevens Tenotomy Scissors Supercut Curved 11.5cm',
      'Lahey Forceps 3×3 teeth 16cm',
      'Allis Tissue Forceps 5×6 teeth 16cm',
      'Adson Brown 9×9 Teeth 12cm',
      'US Army Retractor 2/set',
      'Tissue Forceps 1×2 teeth 15cm',
      'Iris Scissors Tc 10cm',
      'Yancoskie Retractor 6 prongs',
      'Freeman Retractor 4 prongs 22mm',
      'Freeman Retractor 4 prongs 38mm',
      'Meyerding Retractor Large 50mm x 90mm 23cm',
      'Lockwood Abdominal Demarcator 32cm',
    ],
  },
  {
    id: 'amputation-instrument-set',
    name: 'Amputation Instrument Set',
    image: '/ss/amputation-instrument-set.jpg',
    description: 'Comprehensive instrument set for amputation procedures.',
    items: [
      'Hibbs Osteotomes 9" Straight 1" (25mm)',
      'Ferguson Frazier Suction Tube 9 Fr',
      'Ruskin Rongeur 6" Straight 3mm Double Action',
      'Lempert Curette 8" Teardrop Cup Size 4/0',
      'Joseph Hook Sharp Single Prong 6" 1/2',
      'Joseph Double Prong Skin Hook 6" 2mm Wide',
      'Ruskin Rongeur 7 1/2" Straight 5mm Double Action',
      'Key Elevator 7 1/2" Squared 0.25"',
      'Key Elevator 7 1/2" Squared 0.5"',
      'Luer Rongeur 7 1/4" Straight 11mm Single Action',
      'Hibbs Osteotome 9" Straight 1/4" (6mm)',
      'Hibbs Osteotome 9" Straight 1/2" (13mm)',
      'Hibbs Osteotome 9" Straight 3/4" (19mm)',
      'Freer Elevator Double Ended With Blunt Sharp Blades 7" 5mm Wide',
      'Hibbs Osteotomes 9" Straight 1 1/4" (32mm)',
      'Putti Bone Rasp Double Ended Flat 10 1/4"',
      'Liston Bone Cutting Forcep Straight 7 1/2"',
      'Satterlee Bone Saw 12" Light Metal Handle Stainless Steel Blade',
      'Liston Amputation Knife 8" Blade',
      'Knife Handle No 3',
      'Knife Handle No 4',
      'Allis Tissue Forceps 4×5 Teeth 6"',
      'Modified Gigli Bone Saw Wire – Turnable',
      'Bailey Saw Guide 12"',
      'Langenbeck Elevator 7 3/4" 17mm Sharp',
      'Crile Wood Needle Holder Tungsten Carbide Jaws Serrated 6"',
      'Mayo Scissors Tungsten Carbide Curved 5 1/2"',
      'Metzenbaum Scissors Standard Curved 7" – Tungsten Carbide',
      'Lister Bandage Scissors 5 1/2"',
      'Thumb Tissue Forceps 1×2 Teeth 6"',
      'Tissue Forceps 4×5 Teeth 6"',
      'Adson Dressing Forceps 4 3/4" Serrated',
      'Halstead Mosquito Forceps Straight 4 3/4"',
      'Halstead Mosquito Forceps Curved 4 3/4"',
      'Kelly Hemostatic Forceps 5 1/2" Curved',
      'Kocher Forceps 5 1/2" Straight',
      'Backhaus Towel Clamp 5 1/4"',
      'Webster Needle Holder 4 3/4" Smooth Jaws – Tungsten Carbide',
      'Mayo Scissors Tungsten Carbide Straight 5 1/2"',
      'Senn Miller Retractor 3 Prongs Sharp 6 1/4"',
      'Senn Miller Retractor 3 Prongs Blunt 6 1/4"',
      'Langenbeck Retractor 8" 3/8" X 1 1/4"',
      'Langenbeck Retractor 8" 1/2" X 1 1/2"',
      'Volkman Retractor 8 1/2" 2 Prongs Sharp',
      'Volkman Retractor 8 1/2" 3 Prongs Sharp',
      'Hibbs Retractor 9 1/4" 1" X 3" Blade',
      'Weitlaner Retractor 5 1/2" 3×4 Sharp Prongs',
      'Weitlaner Retractor 3×4 Teeth 5 1/2" Blunt',
      'Steel Ruler',
    ],
  },
  {
    id: 'bartholin-cyst-excision-instrument-set',
    name: 'Bartholin Cyst Excision Instrument Set',
    image: '/ss/bartholin-cyst-excision-instrument-set-.jpg',
    description: 'Instrument set tailored for Bartholin cyst excision procedures.',
    items: [
      'Mayo Scissors Tungsten Carbide Straight 6 3/4"',
      'Mayo Scissors Tungsten Carbide Curved 6 3/4"',
      'Metzenbaum Scissors Standard Curved 7" – Tungsten Carbide',
      'Dressing Forceps 5 1/2" Serrated',
      'Thumb Tissue Forceps 1×2 Teeth 5 1/2"',
      'Halstead Mosquito Forceps Curved 4 3/4"',
      'Rochester Pean Forceps 6 1/4" Curved',
      'Backhaus Towel Clamp 5 1/4"',
      'Foerster Sponge Forceps Straight 9 1/2" Serrated Jaws',
      'Mayo Hegar Needle Holder Serrated 7" Tungsten Carbide',
      'Allis Tissue Forceps 5×6 Teeth 7 1/2"',
      'Auvard Weighted Vaginal Speculum 2 3/4" X 1 1/2" Blade 2.5 Lbs',
      'Sims Vaginal Retractor Double Ended Medium',
      'Knife Handle No 3',
    ],
  },
  {
    id: 'basic-eye-instrument-set',
    name: 'Basic Eye Instrument Set',
    image: '/ss/basic-eye-instrument-set.jpg',
    description: 'Foundational ophthalmic instrument set for basic eye procedures.',
    items: [
      'Iris Forceps 4" 1×2 Teeth Standard Straight Pattern',
      'Eye Suture Scissors Curved Pointed Blades',
      'Knife Handle No 7',
      'Knife Handle No 3',
      'Castroviejo Needle Holder 5 1/2" Tungsten Carbide with Lock Straight Serrated',
      'Eye Scissors Curved 4" – Sharp Tips',
      'Eye Scissors Straight 4" – Sharp Tips',
      'Castroviejo Corneal Scissors 4 1/4" Curved Left',
      'Castroviejo Corneal Scissors 4 1/4" Curved Right',
      'Stevens Tenotomy Scissors Slender Style Straight 4 1/2" – Blunt Tips',
      'Chalazion Mucocele Retractor 10×16 mm 9 cm',
      'Arruga Capsule Forceps 4" Curved Standard',
      'Castroviejo Suture Forceps 4" 1×2 0.9mm Teeth',
      'Von Graefe Fixation Forceps 4 3/8" Without Catch Non-magnetic',
      'Iris Forceps 4" 1×2 Teeth Standard Pattern Half Curved',
      'Miniature Blade Breaker Straight With Lock',
      'Eye Dressing Forceps Delicate Pattern Serrated 4" Half Curved Tips',
      'Eye Dressing Forceps Delicate Pattern Serrated 4" Straight Tips',
      'Castroviejo Caliper 3 1/4"',
      'Castroviejo Cyclodialysis Spatula 0.75mm Wide',
      'Von Graefe Strabismus Hook Medium',
      'Desmarres Lid Retractor Size 3',
      'Castroviejo Eye Speculum 3 3/4" Medium 15X5mm O.D',
      'Lancaster Eye Speculum Non-Magnetic',
      'Stitch Scissors Curved 3 3/4" Fine Tips – Blunt Blades',
      'Backhaus Towel Clamp 3 1/2"',
      'Halstead Mosquito Micro Forceps Very Delicate Pattern Curved 5"',
      'Halstead Mosquito Micro Forceps Very Delicate Pattern Straight 5"',
      'Iris Scissors Curved 4" – Sharp Tips',
      'Iris Scissors Straight 4" – Sharp Tips',
    ],
  },
 {
    id: 'basic-hip-instrument-set',
    name: 'Basic Hip Instrument Set',
    image: '/ss/basic-hip-instrument-set.jpg',
    description: 'Comprehensive instrument set for basic hip procedures.',
    items: [
      'Hibbs Osteotome 9" Straight 3/8" (10mm)',
      'Allis Tissue Forceps 4×5 Teeth 7 1/2"',
      'Steel Ruler',
      'Stille-Liston Bone Cutting Forceps Angled Blade 10 1/2"',
      'Stille Luer Rongeur 8 1/2" Curved 10mm Double Action',
      'Spratt (Brun) Mastoid Curette 6 1/2" Oval Cups Size 2/0 (4.8mm)',
      'Spratt (Brun) Mastoid Curette 6 1/2" Oval Cups Size 2 (8.3mm)',
      'Spratt (Brun) Mastoid Curette 6 1/2" Oval Cups Size 4 (11.8mm)',
      'Spratt (Brun) Mastoid Curette 6 1/2" Oval Cups Size 6 (14.0mm)',
      'Beckman Retractor Hinged 4×4 Teeth 12 1/2" 3/4" X 1" Sharp',
      'Hohmann Retractor 9 1/4" 10mm Wide Blade',
      'Hohmann Retractor 9 1/4" 22mm Wide Blade',
      'Hohmann Retractor 9 1/4" 70mm Wide Blade',
      'Volkman Retractor 8 1/2" One Sharp Prong',
      'Hibbs Osteotome 9" Straight 1/4" (6mm)',
      'Adson Retractor 4×4 Straight Sharp Teeth 3/4" x 3/4"',
      'Hibbs Osteotome 9" Straight 1/2" (13mm)',
      'Hibbs Osteotome 9" Straight 5/8" (16mm)',
      'Hibbs Osteotome 9" Straight 3/4" (19mm)',
      'Putti Bone Rasp Double Ended Round and Flat 11 3/4"',
      'Key Elevator 8 1/4" Squared 1.0"',
      'Knife Handle No 4',
      'Knife Handle No 7',
      'Knife Handle No 4L',
      'Richardson Eastman Retractors Double Ended Set Of Two 10"',
      'Allis Tissue Forceps 4×5 Teeth 6"',
      'Modified Gigli Bone Saw Wire – Turnable',
      'Bailey Saw Guide 12"',
      'Langenbeck Elevator 7 3/4" 17mm Sharp',
      'Coller Crile Forceps Curved 6 1/4"',
      'Mayo Scissors Tungsten Carbide Straight 6 3/4"',
      'Mayo Scissors Tungsten Carbide Curved 6 3/4"',
      'Metzenbaum Scissors Standard Curved 9" – Tungsten Carbide',
      'Metzenbaum Scissors Standard Curved 7" – Tungsten Carbide',
      'Metzenbaum Scissors Standard Curved 8" – Tungsten Carbide',
      'Thumb Tissue Forceps 1×2 Teeth 5 1/2"',
      'Dressing Forceps 5 1/2" Serrated',
      'Adson Dressing Forceps 4 3/4" Serrated',
      'Adson Tissue Forceps 4 3/4" 1×2 Teeth',
      'Russian Tissue Forceps 6"',
      'Russian Tissue Forceps 8"',
      'Halstead Mosquito Forceps Curved 4 3/4"',
      'Crile Hemostatic Forceps Curved 5 1/2"',
      'Crile Rankin Hemostatic Forceps Curved 6 1/4"',
      'Yankauer Suction Tube 20 Fr Standard Size',
      'Rochester Pean Forceps 8" Curved',
      'Rochester Ochsner Forceps Straight 8"',
      'Gemini Mixter 9" Delicate Full Curved Jaws',
      'Backhaus Towel Clamp 5 1/4"',
      'Foerster Sponge Forceps Straight 9 1/2" Serrated Jaws',
      'Mayo Hegar Needle Holder Serrated 7" Tungsten Carbide',
      'Mayo Hegar Needle Holder Serrated 8" Tungsten Carbide',
      'Crile Wood Needle Holder Tungsten Carbide Jaws Serrated 7"',
      'Gelpi Retractor 6 1/2" Standard 16.5cm Sharp Tips',
      'Volkman Retractor 8 1/2" 4 Prongs Sharp',
      'Bennett Tibia Retractor Large 9 1/2"',
      'Hibbs Retractor 9 1/4" 1" X 3" Blade',
      'Weitlaner Retractor 3×4 Teeth 6 1/2" Sharp',
    ],
  },
 {
    id: 'basic-laparotomy-set',
    name: 'Basic Laparotomy Set',
    image: '/ss/Basic-Laparotomy-Surgical-Set.jpg',
    description: 'Essential instruments for general laparotomy procedures.',
    items: [
      'Yankauer Suction Tube 20 Fr Standard Size',
      'Ribbon Retractor Malleable 13" x 2.0"',
      'Deaver Retractor Plain Handle 1" X 9"',
      'Deaver Retractor Plain Handle 1" X 13"',
      'Deaver Retractor Plain Handle 2" X 9"',
      'Goelet Retractor Double Ended 7 1/2"',
      'Lahey Gall Duct Forceps 7 1/2"',
      'Metzenbaum Scissors Standard Straight 9" – Tungsten Carbide',
      'Metzenbaum Scissors Standard Curved 9" – Tungsten Carbide',
      'Mayo Hegar Needle Holder Serrated 7" Tungsten Carbide',
      'Mayo Hegar Needle Holder Serrated 8" Tungsten Carbide',
      'Mayo Hegar Needle Holder Serrated 10 1/2" Tungsten Carbide',
      'Ribbon Retractor Malleable 13" x 1.25"',
      'Schnidt Tonsil Hemostatic Forceps 7 1/2" Slight Curved',
      'Thumb Tissue Forceps 1×2 Teeth 8"',
      'Knife Handle No 3',
      'Knife Handle No 4',
      'Knife Handle No 7',
      'Instrument Holder 8"',
      'Instrument Holder 10"',
      'Forcep Instrument Holder 12"',
      'Allis Tissue Forceps 4×5 Teeth 6"',
      'Backhaus Towel Clamp 5 1/4"',
      'Poole Suction Tube Straight with Removable Outer Tube 30 Fr',
      'Allis Willauer Tissue Forceps 5X6 Teeth 10"',
      'Mayo Dissecting Scissors Curved 6 3/4"',
      'Metzenbaum Dissecting Scissors Standard Curved 7"',
      'Halstead Mosquito Forceps Straight 4 3/4"',
      'Halstead Mosquito Forceps Curved 4 3/4"',
      'Kelly Hemostatic Forceps 5 1/2" Straight',
      'Kelly Hemostatic Forceps 5 1/2" Curved',
      'Rochester Pean Forceps 6 1/4" Curved',
      'Rochester Pean Forceps 10" Curved',
      'Rochester Ochsner (Kocher) Forceps Straight 1×2 Teeth 10"',
      'Mixter Hemostatic Forceps 9" Fully Curved Serrated',
      'Foerster Sponge Forceps Straight 9 1/2" Serrated Jaws',
      'Mayo Dissecting Scissors Straight 6 3/4"',
      'Babcock Intestinal Forceps 6 1/4"',
      'Babcock Intestinal Forceps 8"',
      'Dressing Forceps 5 1/2" Serrated',
      'Thumb Tissue Forceps 1×2 Teeth 5 1/2"',
      'Russian Tissue Forceps 8"',
      'Adson Forceps 4 3/4" Micro with 1×2 Teeth',
      'Balfour Abdominal Retractor 7" Spread Standard',
      'Richardson Retractor Hollow Grip Handle 9 1/2" 1" X 3/4"',
      'Richardson Retractor Hollow Grip Handle 9 1/2" 1 1/2"x 1 1/2"',
      'Ribbon Retractor Malleable 13" x 1.0"',
    ],
  },
 {
    id: 'basic-major-orthopedic-instrument-set',
    name: 'Basic Major Orthopedic Instrument Set',
    image: '/ss/basic-major-orthopedic-instrument-set.jpg',
    description: 'Comprehensive instruments for major orthopedic procedures.',
    items: [
      'Volkman Retractor 8 1/2" One Sharp Prong',
      'Steel Ruler',
      'Frazier Suction Tube 8 Fr',
      'Frazier Suction Tube 12 Fr',
      'Beyer-Stille Rongeur 7" 4x15mm Bite Curved',
      'Schnidt Tonsil Hemostatic Forceps 7 1/2" Slight Curved',
      'Ruskin Bone Cutting Forceps Angled Jaw 7 1/2"',
      'Stille Luer Rongeur 8 1/2" Curved 10mm Double Action',
      'Kern Bone Holding Forcep 8 1/2" Without Ratchet',
      'Lambotte Bone Holding Forcep 10 1/2" Swivel Head Adjustable Jaw With Ratchet',
      'Lane Bone Forcep 13" Standard 2×2 Teeth Serrated Jaws With Ratchet Maximun Opening 34mm',
      'Lowman Bone Clamp 5" Jaws 1×2 Maximum Cap Opening 1"',
      'Lowman Bone Clamp 8" Jaws 1×2 Maximum Cap Opening 2 1/2"',
      'Ferguson Angiotribe Forceps Curved 6 1/2"',
      'Hibbs Osteotome 9" Straight 1/4" (6mm)',
      'Hibbs Osteotomes 9" Curved 3/8" (10mm)',
      'Hibbs Osteotome 9" Straight 1/2" (13mm)',
      'Hibbs Osteotomes 9" Curved 5/8" (16mm)',
      'Hibbs Osteotome 9" Straight 3/4" (19mm)',
      'Hibbs Osteotomes 9" Curved 1" (25mm)',
      'Hibbs Osteotomes 9" Straight 1 1/8" (29mm)',
      'Hibbs Gouge 9 1/2" Straight 1/4"',
      'Hibbs Gouge 9 1/2" Curved 3/8"',
      'Knife Handle No 3',
      'Knife Handle No 4',
      'Mayo Hegar Needle Holder Serrated 8" Tungsten Carbide',
      'Mayo Scissors Tungsten Carbide Curved 5 1/2"',
      'Mayo Scissors Tungsten Carbide Straight 6 3/4"',
      'Mayo Scissors Tungsten Carbide Curved 6 3/4"',
      'Metzenbaum Scissors Standard Straight 7" – Tungsten Carbide',
      'Esmarch Plaster Shears 8"',
      'Thumb Tissue Forceps 1×2 Teeth 6"',
      'Tissue Forceps 4×5 Teeth 6"',
      'Adson Forceps 1×2 Teeth 4 3/4" Delicate',
      'Crile Hemostatic Forceps Curved 5 1/2"',
      'Rochester Ochsner Forceps Straight 8"',
      'Backhaus Towel Clamp 5 1/4"',
      'Mayo Scissors Tungsten Carbide Straight 5 1/2"',
      'Crile Wood Needle Holder Tungsten Carbide Jaws Serrated 8"',
      'Meyerding Retractor 9 1/2" 3 1/2" X 2" Large',
      'Meyerding Retractor 9 1/2" 2" X 5/8" Small',
      'Israel Retractor Four Blunt Prongs 1 1/2" x 1 5/8" 9"',
      'Volkman Retractor Ring Handle 8 3/4" Four Sharp Prongs',
      'Volkman Retractor Ring Handle 8 3/4" Four Blunt Prongs',
      'Bennett Tibia Retractor Small 9 1/2"',
      'Bennett Tibia Retractor Large 9 1/2"',
      'Hibbs Retractor 9 1/4" 1" X 3" Blade',
      'Beckman Retractor Hinged 4×4 Teeth 12 1/2" 3/4" X 1" Sharp',
    ],
  },
  {
    id: 'small-fragment-locking-non-locking-set',
    name: 'Small Fragment Locking and Non-Locking Set',
    image: '/ss/small fragment locking and non locking set.png',
    description: 'Orthopedic plating set covering small fragment locking and non-locking systems.',
    items: [
      'Assorted small fragment locking plates (T, L, straight)',
      'Assorted small fragment non-locking plates',
      'Locking screws assortment (2.7mm, 3.5mm)',
      'Cortical and cancellous screws assortment',
      'Drill bits and sleeves compatible with small fragment systems',
      'Screwdrivers (hex/star) and handles',
      'Plate benders and bending irons',
      'Depth gauge and countersink tools',
      'Tap sets for corresponding screw sizes',
      'Reduction forceps and clamps',
      'Bone holding forceps',
      'Torque-limiting driver',
      'Sterilization case/trays',
    ],
  },
  {
    id: 'orthopedic-surgical-instruments-trauma-kit',
    name: 'Orthopedic Surgical Instruments Trauma Kit',
    image: '/ss/Orthopedic Surgical Instruments Trauma Kit.jpg',
    description: 'Comprehensive orthopedic trauma kit for reduction and fixation procedures.',
    items: [
      'Reduction forceps and clamps',
      'Bone holding forceps',
      'K-wire set (assorted sizes)',
      'Drill bits and sleeves',
      'Depth gauge',
      'Countersink and taps',
      'Screwdrivers (hex/star) and handles',
      'T-handle chuck',
      'Plate benders',
      'Assorted screws (cortical/cancellous)',
      'Sterilization tray',
    ],
  },
 {
     id: 'cannulated-instruments-set-6-5-4-5',
     name: 'Cannulated Instruments Set 6.5mm - 4.5mm',
     image: '/ss/Cannulated instruments set 6.5mm - 4.5mm.png',
     description: 'Cannulated instruments set for 6.5mm and 4.5mm systems.',
     items: [],
   },
  {
     id: 'cannulated-instruments-set-3-5-4-0',
     name: 'Cannulated Instruments Set 3.5mm - 4.0mm',
     image: '/ss/Cannulated instruments set 3.5mm - 4.0mm.png',
     description: 'Cannulated instruments set for 3.5mm and 4.0mm systems.',
     items: [],
   },
  {
     id: 'cement-removal-set',
     name: 'Cement Removal Set',
     image: '/ss/Cement removal set.png',
     description: 'Instruments for removal of bone cement during revision arthroplasty and orthopedic procedures.',
     items: [],
   },
  {
     id: 'large-fragment-set-4-5',
     name: 'Large Fragment Set 4.5mm',
     image: '/ss/large fragment set 4.5mm.png',
     description: 'Large fragment plating set compatible with 4.5mm systems.',
     items: [],
   },
  {
     id: 'basic-plastic-set',
     name: 'Basic Plastic Set',
     image: '/ss/basic-plastic-set.jpg',
    description: 'Core instruments for basic plastic surgery procedures.',
    items: [
      'Halsey Needle Holder TC Smooth 5"',
      'Ragnell Dissecting Scissors Cvd 5"',
      'Semkin Tissue Forceps 1×2 Teeth 5"',
      'Semkin Tissue Forceps Serr 5"',
      'Alm Retractor 2 3/4"',
      'Iris Scissors Straight 4 1/2"',
      'Iris Scissors Curved 4 1/2"',
      'Baron Suction Tube 3 French',
      'Baron Suction Tube 5 French',
      'Frazier Suction Tube 7 French',
      'Adson Tissue Forceps 1×2 Teeth 4 3/4"',
      'Adson Dressing Forceps Serr 4 3/4"',
      'Castroviejo Needle Holder Smooth Tip 14cm',
      'Stainless Steel Sterilizing Box',
      'Silicone Matt for Box',
    ],
  },
 {
    id: 'basic-vaginal-instrument-set',
    name: 'Basic Vaginal Instrument Set',
    image: '/ss/basic-vaginal-instrument-set.jpg',
    description: 'Essential instruments for basic gynecological and vaginal procedures.',
    items: [
      'Dressing Forceps 8" Serrated',
      'Knife Handle No 4L',
      'Knife Handle No 4',
      'Knife Handle No 3',
      'Skene Uterine Tenaculum Forceps 9"',
      'Auvard Weighted Vaginal Speculum 2 3/4" X 1 1/2" Blade 2.5 Lbs',
      'Sims Vaginal Retractor Grip Handle Medium 3" X 1 1/4"',
      'Schroeder Uterine Tenaculum Forceps 9 1/2"',
      'Bozeman Uterine Dressing Forceps Curved 10"',
      'Deaver Retractor Plain Handle 1" X 9"',
      'Parker Retractor Double Ended Set Of Two 5/8" X 5"',
      'Thumb Tissue Forceps 1×2 Teeth 8"',
      'Thumb Tissue Forceps 1×2 Teeth 5"',
      'Operating Scissors Sharp Sharp Straight 5 1/2"',
      'Dressing Forceps 5 1/2" Serrated',
      'Backhaus Towel Clamp 5 1/4"',
      'Allis Tissue Forceps 5×6 Teeth 6"',
      'Foerster Sponge Forceps Straight 9 1/2" Serrated Jaws',
      'Rochester Ochsner Forceps Straight 6 1/4"',
      'Rochester Pean Forceps 6 1/4" Curved',
      'Kelly Hemostatic Forceps 5 1/2" Curved',
      'Kelly Hemostatic Forceps 5 1/2" Straight',
      'Metzenbaum Dissecting Scissors Standard Curved 7"',
      'Mayo Dissecting Scissors Curved 6 3/4"',
      'Mayo Dissecting Scissors Straight 6 3/4"',
    ],
  },
 {
    id: 'blepharoplasty-set-b',
    name: 'Blepharoplasty Set-B',
    image: '/ss/Blepharoplasty-Set-B.jpg',
    description: 'Specialized instruments for eyelid surgery (blepharoplasty).',
    items: [
      'Adson-Brown Tissue Forceps TC 7×7 Teeth, 12cm',
      'Ribbon-Type Blepharoplasty Scissors Curved 10.5cm',
      'Ribbon-Type Blepharoplasty Scissors Straight 10.5cm',
      'Castroviejo Needle Holder TC Straight with Lock, 14cm',
      'Castroviejo Suture Forceps 1×2 Teeth 0.3mm Wide 10.5cm',
      'Castroviejo Suture Forceps 1×2 Teeth 0.5mm 10.5cm',
      'Castroviejo Suture Forceps Straight 0.9mm 10.5cm',
      'Gillies Needle Holder TC 12.5cm',
      'Frazier Tissue Hook 12.5cm',
      'Green Fixation Forceps 9mm 10.5cm',
      'Guthrie Fixation Hook 2 Large Prongs 12.5cm',
      'Ribbon Iris Scissors Curved 10.5cm',
      'Ribbon Iris Scissors Straight 10.5cm',
      'Kaye Blepharoplasty Rake 4 Prongs 13.5cm',
      'Kaye Blepharoplasty Rake 5 Prongs 13.5cm',
      'Kaye Blepharoplasty Scissors Curved Serrated 11.5cm',
      'Adson TC Tissue Forceps with Tying Platform 1×2 Teeth 12cm',
      'Stevens Tenotomy Scissors Curved Blunt/Blunt 11.5cm',
      'Stevens Tenotomy Scissors Curved Sharp/Sharp 11.5cm',
      'Wagner Scissors – Straight, Sharp/Sharp 11.5cm',
      'Webster Needle Holder TC Straight Smooth 13.5cm',
    ],
  },
 {
    id: 'blepharoplasty-set-c',
    name: 'Blepharoplasty Set-C',
    image: '/ss/Blepharoplasty-Set-C.jpg',
    description: 'Specialized instruments for eyelid surgery (blepharoplasty).',
    items: [
      'Gillies Delicate Retractor 19cm',
      'Joseph Skin Hook 16cm 2mm Double Prong Sharp',
      'Desmarres Lid retractor 9x12mm 13 cm',
      'Scalpel handle No #3 12.5cm',
      'Jaeger Lid Plate Stainless Steel',
      'Mayo Scissors Straight T.C 14.5cm',
      'Steven Delicate scissors curved sharp 11.5cm',
      'Neivert Needle holders smooth 12.5cm',
      'Halsted Mosquito Hemostatic forceps curved 12.5cm',
      'Backhaus Towel clamp 8.5cm',
      'Micro Adson Delicate forceps Tissue 1×2 teeth 12cm',
      'Micro Adson Delicate forceps Tissue 1×2 teeth 15cm',
      'Castroviejo Calipers Measuring Range 20mm 7cm',
      'Castroviejo Needle Holder 14cm',
      'Castroviejo Scissors 14cm',
      'Putterman Eyelid Clamp',
      'Gladstone Transmarginal Clamp',
      'Berke Ptosis Froscep 12 cm',
    ],
  },
 {
    id: 'blepharoplasty-set-d',
    name: 'Blepharoplasty Set-D',
    image: '/ss/Blepharoplasty-Set-D.jpg',
    description: 'Specialized instruments for eyelid surgery (blepharoplasty).',
    items: [
      'Scalpel Handle #3 Standard',
      'Stevens Scissors 11.5cm Curved Sharp',
      'Stevens Scissors 11.5cm Curved Blunt',
      'Neivert Needle Holder 12.5cm',
      'Halsted Mosquito Forceps 12.5cm Curved',
      'Backhaus Towel Clamp 8.5cm',
      'Gillies Dura And Skin Retractor Hook 19cm Small',
      'Joseph Delicate Retractor 17cm 2 Prong 5mm Sharp',
      'Joseph Delicate Tracheal Retractor 16cm 2 Prong 8mm Blunt',
      'Supercut Mayo Scissors 14cm Straight',
      'Desmarres Lid Retractor #1 14cm Small 9x12mm',
      'Castroviejo Measuring guage 7 cm Measuring Guage 20mm',
      'Bishop Harmon Iris Forceps 1X2 teeth 0.3mm',
      'Castroviejo Suturing Forceps 1X2 teeth 0.9mm',
    ],
  },
 {
    id: 'breast-augmentation-set-a',
    name: 'Breast Augmentation Set-A',
    image: '/ss/Breast-Augmentation-Set-A.jpg',
    description: 'Comprehensive instrument set for breast augmentation procedures.',
    items: [
      'Steel Ruler 6"',
      'Round Scalpel Handle Straight',
      'Emesis Basin 10 oz.',
      'Mayo Dissecting Scissor Curved 6 3/4"',
      'Hartmann Mosquito Straght Serrated 3 1/2"',
      'Halsted Mosquito Forcep Straight 5"',
      'Kocher Forcep Straight 1X2 Teeth 5 1/2"',
      'Tissue Forcep 1X2 Teeth 4 1/2"',
      'Webster Needle Holder Smooth Jaw 5 1/4"',
      'Baumgartner Needle Holder Serrated 5 1/2"',
      'Olsen Hegar Needle Holder 5 1/2"',
      'Heaney Needle Holder 8 1/4"',
      'Goldman-Fox Scissor 5" Curved Serrated',
      'Allis Tissue Forcep 4X5 6"',
      'Iris Scissor Straight Sharp/Sharp 4 1/2"',
      'Iris Scissor Curved Sharp/Sharp 4 1/2"',
      'Joseph Hook 2 Prong Sharp 6 1/4" 2mm',
      'Joseph Hook 2 Prong Sharp 6 1/4" 5mm',
      'Backhaus Towel Clamp 3 1/2"',
      'Frazier Suction Tube 8Fr',
      'Adson Tissue Forcep 1X2 Teeth 4 3/4"',
      'Adson Dressing Forcep Serrated 4 3/4"',
      'Debakey Atrauma Forcep 2mm 7 3/4"',
      'Us Army Retractor Set of 2 Double Ended 8 1/4"',
      'Deaver #4 2X12"',
      'Ribbon Retractor 1/2"×7 3/4"',
      'Senn Miller Double Ended Retractor Sharp 6"',
      'Steven Tenotomy Scissor Straight 4 1/2" Blunt',
      'Steven Tenotomy Scissor Curved 4 1/2" Blunt',
      'Bowman Lach Probe Size 7/8 Chrome',
      'Schnidt Half Curved Tonsil Forcep 7 1/2"',
      'Metzenbaum Scissors Straight 7"',
      'Metzenbaum Scissors Curved 7"',
      'Bipolar Adson Forcep 1mm 4 3/4"',
    ],
  },
  {
    id: 'breast-augmentation-set-b',
    name: 'Breast Augmentation Set-B',
    image: '/ss/Breast-Augmentation-Set-B.jpg',
    description: 'Comprehensive instrument set for breast augmentation procedures.',
    items: [
      'Scalpel Handle No #3',
      'Halsted Mosquito Forceps Curved 12.5cm',
      'Metzenbaum Scissors Supercut 18cm Curved',
      'Gorney Freeman Scissors Supercut Curved 23cm',
      'Mayo Scissors 18cm Straight',
      'Iris Scissors TC Straight 11.5cm',
      'Yankauer Suction Tube 28cm',
      'Frazier Suction Tube 12 FR',
      'Adson Dressing Forceps 12cm',
      'Adson Tissue & Suture Forceps 1×2 teeth with tying platform',
      'Brown-Adson Forceps 9×9 teeth 12cm',
      'Tissue Forceps 1×2 Teeth 15cm',
      'Dressing Forceps Serrated 15cm',
      'Freeman Areola Marker 38mm',
      'Freeman Areola Marker 42mm',
      'Freeman Areola Marker 45mm',
      'Freeman Areola Marker 50mm',
      'McKissock Breast Marker 38mm Keyhole Pattern',
      'McKissock Breast Marker 42mm Keyhole Pattern',
      'McKissock Breast Marker 45mm Keyhole Pattern',
      'Mayo-Hegar Needle Holder TC 16cm',
      'Webster Needle Holder TC Smooth Jaws 13cm',
      'Halsey Needle Holder TC Smooth Jaws 14cm',
      'McKissock Mammaplasty Caliper',
      'Stainless Steel Ruler 15cm',
      'Tebbetts Spatulated Breast Dissector 33cm',
      'Silverstein Breast Dissector',
      'Joseph Hook Sharp 5mm 16cm',
      'Senn Muller Retractor Insulated Sharp',
      'US Army Retractor Set of 2 Insulated',
      'Freeman Retractor 4 Prong 38mm',
      'Pediatric Ribbon Retractor Malleable',
      'Ferreira Fiber Optic Retractor 150x25mm Insulated',
      'Deaver Fiber Optic Retractor',
      'Tebbetts Fiber Optic Retractor 150x25mm Insulated',
    ],
  },
  {
    id: 'breast-augmentation-set-c',
    name: 'Breast Augmentation Set-C',
    image: '/ss/Breast-Augmentation-Set-C.jpg',
    description: 'Comprehensive instrument set for breast augmentation procedures.',
    items: [
      'Adson Dissecting Forceps 1×2 Teeth Straight 12.5cm',
      'Adson Dissecting Forceps Serrated Straight 12.5cm',
      'Baby Crile Needle Holder TC 15cm',
      'Czerny Double Ended Retractor 17.5cm',
      'Deaver Retractor 25x305mm',
      'Dressing Scissors Sharp/Sharp Straight 14.5cm',
      'Fiber Optic Cable',
      'Gillies Skin Hook Large 18cm',
      'Halsted Mosquito Forceps Curved 12.5cm',
      'Barsky Skin Hook Sharp 15cm',
      'Langenbeck Retractor 65x12mm 21cm',
      'Littlewood Tissue Forceps 18.5cm',
      'Mayo Scissors Straight 14cm',
      'Mayo Scissors Curved 17cm',
      'Metzenbaum Scissors Supercut Curved 18cm',
      'Tebbetts Retractor with Fiber Optic Light Guide 80x16mm',
      'Monopolar Cable 3m Length 4mm Pin 4.8mm Dia',
      'Rampley Sponge Holder Forceps Straight 24cm',
      'Roberts Artery Forceps 23cm',
      'Scalpel Handle No 3',
      'Spencer Wells Artery Forceps Straight 18cm',
    ],
  },
  {
    id: 'cataract-surgery-instrument-set',
    name: 'Cataract Surgery Instrument Set',
    image: '/ss/cataract-surgery-instrument-set.jpg',
    description: 'Specialized ophthalmic instruments for cataract surgery.',
    items: [
      'Elsching O’brien Fixation Forceps 1×2 Delicate Angular Teeth With Catch 4″',
      'Castroviejo Corneal Scissors 4 1/4″ Curved Left',
      'Eye Scissors Straight 4″ – Sharp Tips',
      'Eye Scissors Curved 4″ – Sharp Tips',
      'Castroviejo Needle Holder 5 1/2″ Tungsten Carbide with Lock Straight Serrated',
      'Park Maumenee Eye Speculum Non Magnetic Guard Over Locking Screw',
      'Castroviejo Blade Breaker And Holder 5 1/4″ Slide Catch',
      'Von Graefe Strabismus Hook Medium',
      'Wilder Lens Loop Smooth',
      'Kirby Double Hook And Expressor',
      'Troutman Barraquer Colibri Type Corneal Utility Forceps 3″ 0.4mm',
      'Castroviejo Corneal Scissors 4 1/4″ Curved Right',
      'Castroviejo Suture Forceps 4″ 1×2 0.5mm Teeth',
      'Castroviejo Capsule Forceps 4″ Max Opening 5mm',
      'Westcott Tenotomy Scissors 4 1/2″ – Blunt Tips With Spring Handle',
      'Dewecker Iris Scissors 4 1/2″ Angled Sharp Sharp',
      'Castroviejo Corneal Scissors 4 1/4″ Curved Right',
      'Castroviejo Corneal Scissors 4 1/4″ Curved Left',
      'Knife Handle No 3',
      'Knife Handle No 7',
      'Eye Suture Scissors Curved Pointed Blades',
      'Castroviejo Cyclodialysis Spatula 0.75mm Wide',
      'Iris Scissors Straight 4″ – Sharp Tips',
      'Iris Scissors Curved 4″ – Sharp Tips',
      'Halstead Mosquito Micro Forceps Very Delicate Pattern Straight 5″',
      'Halstead Mosquito Micro Forceps Very Delicate Pattern Curved 5″',
      'Backhaus Towel Clamp 3 1/2″',
      'Stitch Scissors Curved 3 3/4″ Fine Tips – Blunt Blades',
      'Lancaster Eye Speculum Non-Magnetic',
      'Castroviejo Eye Speculum 3 3/4″ Medium 15X5mm O.D',
      'Desmarres Lid Retractor Size 3',
      'Von Graefe Strabismus Hook Medium',
      'Miniature Blade Breaker Straight With Lock',
      'Castroviejo Caliper 3 1/4″',
      'Eye Dressing Forceps Delicate Pattern Serrated 4″ Straight Tips',
      'Eye Dressing Forceps Delicate Pattern Serrated 4″ Half Curved Tips',
      'Iris Forceps 4″ 1×2 Teeth Standard Straight Pattern',
      'Iris Forceps 4″ 1×2 Teeth Standard Pattern Half Curved',
      'Von Graefe Fixation Forceps 4 3/8″ Without Catch Non-magnetic',
      'Castroviejo Suture Forceps 4″ 1×2 0.9mm Teeth',
      'Arruga Capsule Forceps 4″ Curved Standard',
      'Chalazion Mucocele Retractor 10×16 mm 9 cm',
      'Stevens Tenotomy Scissors Slender Style Straight 4 1/2″ – Blunt Tips',
    ],
  },
  {
    id: 'cesarean-instrument-set',
    name: 'Cesarean Instrument Set',
    image: '/ss/cesarean-instrument-set.jpg',
    description: 'Comprehensive instrument set for cesarean section procedures.',
    items: [
      'Knife Handle No 3',
      'Allis Tissue Forceps 4×5 Teeth 6″',
      'Yankauer Suction Tube 20 Fr Standard Size',
      'Sponge Bowl Size 12.5x6cm',
      'Sponge Bowl Capacity 1200 ml',
      'Rochester Ochsner Forceps Straight 8″',
      'Rochester Ochsner Forceps Curved 8″',
      'Metzenbaum Dissecting Scissors Standard Straight 7″',
      'Mayo Hegar Needle Holder 8″',
      'Mayo Hegar Needle Holder 6″',
      'Mayo Dissecting Scissors Straight 6 3/4″',
      'Mayo Dissecting Scissors Curved 6 3/4″',
      'Knife Handle No 4',
      'Babcock Intestinal Forceps 6 1/4″',
      'Kidney/Emesis Basin Size 20.5×10.8x4cm',
      'Iodine/Solution Cup Size 8.3×5.1cm',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Foerster Sponge Forceps Curved 9 1/2″ Serrated Jaws',
      'Dressing Forceps 8″ Serrated',
      'Dressing Forceps 5 1/2″ Serrated',
      'Doyen Vaginal Retractor Blade 2 1/8″x 3″ Size 9″',
      'Crile Hemostatic Forceps Straight 5 1/2″',
      'Crile Hemostatic Forceps Curved 5 1/2″',
      'Braun Episitomy Scissors 5 1/2″ Angular',
      'Backhaus Towel Clamp 5 1/4″',
      'Baby Farabeuf Retractor Double Ended Set Of Two 4 3/4″',
    ],
  },
  {
    id: 'cleft-palate-repair-instruments',
    name: 'Cleft & Palate Repair Instruments',
    image: '/ss/Cleft-Palate-Repair-Instruments.jpg',
    description: 'Comprehensive instrument set for cleft lip and palate repair procedures.',
    items: [
      'Scalpel Round Handle 16cm',
      'Adson Forceps 15cm Serrated',
      'Adson Forceps 15cm 1×2 Teeth',
      'Iris Supercut Scissors 11.5cm Straight',
      'Iris Supercut Scissors 11.5cm Curved',
      'Ragnell Kilner Scissors 13cm Curved',
      'Supercut Plus Kelly T.C. Scissors 16cm Curved',
      'Metzenbaum T.C. Scissors 18cm Curved',
      'Crile Wood T.C. Needle Holder 15cm',
      'Blocksma Cleft Palate Hook 18cm 3mm 2 Prong',
      'Cleft Palate Raspatory 14cm #1 Left',
      'Cleft Palate Raspatory 14cm #2 Right',
      'Kahre Cleft Palate Raspatory 17cm',
      'Mcindoe Cleft Palate Raspatory 16.5cm',
      'Muco-Periosteal Retractor 19cm',
      'Wang Cleft Palate Elevator 15.5cm',
      'Wang Cleft Palate Elevator 18cm Right',
      'Wang Cleft Palate Elevator 18cm Left',
      'Wang Cleft Palate Elevator 18cm Right Angled',
      'Wang Cleft Palate Elevator 18cm Left Angled',
      'Castroviejo Caliper 7cm 20mm Measuring Range',
      'Dingman Mouth Gag Complete',
    ],
  },
  {
    id: 'dilation-and-curettage-set',
    name: 'Dilation and Curettage Set',
    image: '/ss/dilation-and-curettage-set.jpg',
    description: 'Comprehensive instrument set for dilation and curettage procedures.',
    items: [
      'Knife Handle No 3',
      'G08-04 Knife Handle No 4L',
      'Backhaus Towel Clamp 5 1/4″',
      'Dressing Forceps 8″ Serrated',
      'Graves Vaginal Speculum Medium 4″ 1 1/4″',
      'Jackson Vaginal Retractor Small 3″ X 1 1/2″',
      'Jackson Vaginal Retractor Medium 3 1/2″ X 1 1/2″',
      'Hegar Uterine Dilator Double Ended Set Of 8',
      'Bozeman Uterine Dressing Forceps Curved 10″',
      'Schroeder Uterine Tenaculum Forceps 9 1/2″',
      'Sims Uterine Curette Sharp Malleable Shaft 11″ Size 00',
      'Sims Uterine Curette Sharp Malleable Shaft 11″ Size 0',
      'Sims Uterine Curette Sharp Malleable Shaft 11″ Size 3',
      'Sims Uterine Curette Sharp Malleable Shaft 11″ Size 5',
      'Simpson Uterine Sound Silver Plated Graduated In cm12 3/4″',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Heaney Needle Holder Serrated Curved 8″ Tungsten Carbide',
      'Auvard Weighted Vaginal Speculum 2 3/4″ X 1 1/2″ Blade 2.5 Lbs',
      'Jacobs Vulsellum Forceps 2×2 Teeth Serrated Jaws Straight 8 1/4″',
    ],
  },
  {
    id: 'hemorrhoidectomy-instrument-set',
    name: 'Hemorrhoidectomy Instrument Set',
    image: '/ss/hemorrhoidectomy-instrument-set.jpg',
    description: 'Comprehensive instrument set for hemorrhoidectomy procedures.',
    items: [
      'Hirschman Anascope Large',
      'Allis Tissue Forceps 4×5 Teeth 6″',
      'Knife Handle No 3',
      'Brinckerhoff Straight Specula – Medium',
      'Hirschman Anascope Medium',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Backhaus Towel Clamp 5 1/4″',
      'Halstead Mosquito Forceps Straight 4 3/4″',
      'Thumb Tissue Forceps 1×2 Teeth 5 1/2″',
      'Dressing Forceps 5 1/2″ Serrated',
      'Metzenbaum Scissors Standard Curved 5 1/2″ – Tungsten Carbide',
      'Yeoman Biopsy Forceps 4x8mm Bite Complete Ring Handle 14″',
      'Buie Suction Tube With Finger Valve 15 Fr',
      'Pratt Crypt Hook Narrow 8 1/2″',
      'Pratt Straight Probe 11″',
      'Operating Scissors Sharp Blunt Straight 5 1/2″',
      'Hirschman Anascope Medium',
      'Hirschman Anascope Small',
      'Sims Straight Speculum Fenestrated Blades With Set Screw 6″',
      'Allis Tissue Forceps 5×6 Teeth 7 1/2″',
      'Volkman Retractor 8 1/2″ 4 Prongs Sharp',
      'Mayo Hegar Needle Holder Serrated 7″ Tungsten Carbide',
      'Backhaus Towel Clamp 5 1/4″',
      'Pennington Tissue Grasping Forceps 5 1/4″',
      'Rochester Pean Forceps 6 1/4″ Curved',
      'Crile Rankin Hemostatic Forceps Straight 6 1/4″',
      'Dressing Forceps 6″ Serrated',
      'Mayo Scissors Tungsten Carbide Curved 6 3/4″',
      'Mayo Scissors Tungsten Carbide Straight 6 3/4″',
      'Mayo Scissors Tungsten Carbide Curved 5 1/2″',
    ],
  },
  {
    id: 'hysterectomy-instrument-set',
    name: 'Hysterectomy Instrument Set',
    image: '/ss/hysterectomy-instrument-set.jpg',
    description: 'Comprehensive instrument set for hysterectomy procedures.',
    items: [
      'Mayo Hegar Needle Holder Serrated 7″ Tungsten Carbide',
      'Adson Forceps 4 3/4″ Micro with 1×2 Teeth',
      'Balfour Abdominal Retractor 7″ Spread Standard',
      'Richardson Retractor Hollow Grip Handle 9 1/2″ 1″ X 3/4″',
      'Richardson Retractor Hollow Grip Handle 9 1/2″ 1 1/2″x 1 1/2″',
      'Ribbon Retractor Malleable 13″ x 1.0″',
      'Ribbon Retractor Malleable 13″ x 1.25″',
      'Ribbon Retractor Malleable 13″ x 2.0″',
      'Deaver Retractor Plain Handle 1″ X 9″',
      'Deaver Retractor Plain Handle 1″ X 13″',
      'Deaver Retractor Plain Handle 2″ X 9″',
      'Goelet Retractor Double Ended 7 1/2″',
      'Lahey Gall Duct Forceps 7 1/2″',
      'Metzenbaum Scissors Standard Straight 9″ – Tungsten Carbide',
      'Metzenbaum Scissors Standard Curved 9″ – Tungsten Carbide',
      'Russian Tissue Forceps 8″',
      'Mayo Hegar Needle Holder Serrated 8″ Tungsten Carbide',
      'Mayo Hegar Needle Holder Serrated 10 1/2″ Tungsten Carbide',
      'Yankauer Suction Tube 20 Fr Standard Size',
      'Thumb Tissue Forceps 1×2 Teeth 8″',
      'Knife Handle No 3',
      'Knife Handle No 4',
      'Knife Handle No 7',
      'Instrument Holder 8″',
      'Instrument Holder 10″',
      'Forcep Instrument Holder 12″',
      'Metzenbaum Scissors Standard Curved 7″ – Tungsten Carbide',
      'Allis Tissue Forceps 4×5 Teeth 6″',
      'Allis Tissue Forceps 5×6 Teeth 7 1/2″',
      'Poole Suction Tube Straight with Removable Outer Tube 30 Fr',
      'Schnidt Tonsil Hemostatic Forceps 7 1/2″ Slight Curved',
      'Mayo Dissecting Scissors Straight 6 3/4″',
      'Allis Willauer Tissue Forceps 5X6 Teeth 10″',
      'Mixter Thoracic Forceps Right Angle Jaws Longitudinal Serrations 9″',
      'Heaney Needle Holder 8 1/4″ Curved',
      'Heaney Hysterectomy Forceps Heavy Double Tooth 8″',
      'Heaney Ballentine Hysterectomy Forceps Longitudinal Serrations Single Tooth Straight Size 8 1/2″',
      'Heaney Ballentine Hysterectomy Forceps Longitudinal Serrations Single Tooth Curved Size 8 1/2″',
      'Rochester Ochsner Forceps Straight 8″',
      'Rochester Ochsner Forceps Curved 8″',
      'Mayo Dissecting Scissors Curved 6 3/4″',
      'Metzenbaum Dissecting Scissors Standard Curved 7″',
      'Debakey Vascular Tissue Forceps 1.5mm wide Tips 6″',
      'Knife Handle No 3L',
      'Deaver Retractor Plain Handle 1″ X 9″',
      'Deaver Retractor Plain Handle 1″ X 12″',
      'Deaver Retractor Plain Handle 1 1/2″ X 12″',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Halstead Mosquito Forceps Straight 4 3/4″',
      'Halstead Mosquito Forceps Curved 4 3/4″',
      'Kelly Hemostatic Forceps 5 1/2″ Straight',
      'Kelly Hemostatic Forceps 5 1/2″ Curved',
      'Rochester Pean Forceps 6 1/4″ Curved',
      'Rochester Pean Forceps 10″ Curved',
      'Rochester Ochsner (Kocher) Forceps Straight 1×2 Teeth 10″',
      'Mixter Hemostatic Forceps 9″ Fully Curved Serrated',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Babcock Intestinal Forceps 6 1/4″',
      'Babcock Intestinal Forceps 8″',
      'Backhaus Towel Clamp 5 1/4″',
      'Dressing Forceps 5 1/2″ Serrated',
      'Thumb Tissue Forceps 1×2 Teeth 5 1/2″',
    ],
  },
 {
    id: 'knee-instrument-set',
    name: 'Knee Instrument Set',
    image: '/ss/knee-instrument-set.jpg',
    description: 'Specialized instruments for knee procedures.',
    items: [
      'Martin Cartilage Clamp 7 1/2″ Straight',
      'Weitlaner Retractor 3×4 Teeth 5 1/2″ Blunt',
      'Steel Ruler',
      'Freer Elevator Double Ended With Blunt Sharp Blades 7 3/4″ 4.5mm Wide',
      'Blount Knee Retractor 7″',
      'Smillie Meniscus Hook Retractor Blade 3/4″ X 1 3/8″ 5 3/4″',
      'Smillie Cartilage Knife 6 3/4″',
      'Lowe-Breck Cartilage Knife, Straight Edge With Guards, 10 1/2″',
      'Downing Cartilage Knife Concave Edge With Guards 10″',
      'Volkman Retractor 8 1/2″ 4 Prongs Sharp',
      'Knife Handle No 3',
      'Knife Handle No 7',
      'Allis Tissue Forceps 4×5 Teeth 6″',
      'Sayre Periosteal Elevator 6 3/4″ One Straight Blunt One Curved Sharp End',
      'Key Elevator 7 1/2″ Width 3/8″',
      'Key Elevator 8 ¼” Squared 1.0”',
      'Adson Dura Hook Blunt Blade 5mm Right Angle Size 8″',
      'Graham Nerve Hook Blunt 6mm Deep Size 7″',
      'Kelly Hemostatic Forceps 5 1/2″ Curved',
      'Mayo Scissors Tungsten Carbide Curved 6 3/4″',
      'Metzenbaum Scissors Standard Curved 5 1/2″ – Tungsten Carbide',
      'Metzenbaum Scissors Standard Curved 7″ – Tungsten Carbide',
      'Lister Bandage Scissors 5 1/2″',
      'Thumb Tissue Forceps 1×2 Teeth 5 1/2″',
      'Adson Dressing Forceps 4 3/4″ Serrated',
      'Adson Tissue Forceps 4 3/4″ 1×2 Teeth',
      'Tissue Forceps 4×5 Teeth 5 1/2″',
      'Mayo Scissors Tungsten Carbide Straight 6 3/4″',
      'Rochester Ochsner Forceps Straight 6 1/4″',
      'Backhaus Towel Clamp 5 1/4″',
      'Webster Needle Holder 4 3/4″ Smooth Jaws – Tungsten Carbide',
      'Crile Wood Needle Holder Tungsten Carbide Jaws Serrated 7″',
      'Senn Miller Retractor 3 Prongs Sharp 6 1/4″',
      'Senn Miller Retractor 3 Prongs Blunt 6 1/4″',
      'Volkman Retractor 8 1/2″ 2 Prongs Sharp',
    ],
  },
 {
    id: 'laparoscopy-instrument-set',
    name: 'Laparoscopy Instrument Set',
    image: '/ss/laparoscopy-instrument-set.jpg',
    description: 'Specialized instruments for laparoscopy procedures.',
    items: [
      'Mayo Dissecting Scissors Straight 6 3/4″',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Backhaus Towel Clamp 5 1/4″',
      'Coller Crile Forceps Curved 6 1/4″',
      'Hudson Dressing Forceps 4 3/4″ Serrated',
      'Crile Wood Needle Holder 6″ Serrated',
      'Graves Vaginal Speculum Medium 4″ 1 1/4″',
      'Schroeder Uterine Tenaculum Forceps 9 1/2″',
      'Simpson Uterine Sound Silver Plated Graduated In cm12 3/4″',
      'Sims Vaginal Retractor Double Ended Small',
      'Auvard Weighted Vaginal Speculum 2 3/4″ X 1 1/2″ Blade 2.5 Lbs',
      'Barrett Uterine Tenaculum Forceps 7″',
      'Knife Handle No 3',
      'Allis Tissue Forceps 4×5 Teeth 6″',
    ],
  },
 {
    id: 'laparoscopic-23pc-set',
    name: '23PC Laparoscopic Surgery Set',
    image: '/ss/23PC Laparoscopic Surgery Set.jpeg',
    description: 'Compact 23-piece laparoscopic surgery set for minimally invasive procedures.',
    items: [],
  },
 {
    id: '72-pcs-dental-kit',
    name: '72 pcs Dental Kit',
    image: '/ss/72 pcs Dental Kit.jpeg',
    description: 'Comprehensive 72-piece dental instrument kit suitable for a wide range of dental procedures.',
    items: [],
  },
 {
    id: 'mammaplasty-set',
    name: 'Mammaplasty Set',
    image: '/ss/Mammaplasty-Set.jpg',
    description: 'Specialized instrument set for mammaplasty procedures.',
    items: [
      'Scalpel Blades #15 – Sterile 100/Box',
      'Scalpel Handle #7',
      'Jabeley Scissors 13cm Curved Sharp/Sharp',
      'Metzenbaum Scissors 20cm Curved Standar Pattern',
      'Micro Adson Forceps 12cm 1×2 Teeth 0.8mm Tips',
      'Gruenwald Nasal Bayonet Forceps 19.5cm Serrated Tips',
      'Baby Crile Wood Needle Holder 15cm',
      'SBaby Crile Wood T.C. Needle Holder 15cm',
      'Jabeley Supercut Scissors 13cm Curved Sharp/Sharp',
      'Solz Gold Tip TC with Supercut Scissors 20cm Curved Slight Bevel On Shank',
      'Solz Gold Tip TC with Supercut Scissors 20cm Curved Strong Bevel On Shank',
      'Farabeuf Baby Retractors 12cm Double Ended Set Of 2',
      'Langenbeck Kocher Retractor #13 15mm Wide X 80mm Deep 21cm',
      'Atraumatic Breast Dissector 34cm',
      'Breast Hook Dissector Curved to Left 36cm',
      'Breast Hook Dissector Curved to Right 36cm',
      'Areola Marker Blunt 36mm Diameter',
      'Areola Marker Blunt 40mm Diameter',
      'Areola Marker Blunt 42mm Diameter',
      'Areola Marker Blunt 45mm Diameter',
      'Marx Breast Retractor 27cm 125 X 30mm',
      'Round Bowl For Solutions/Marking Color 60x30mm 60cc',
    ],
  },
 {
    id: 'minor-basic-instrument-set',
    name: 'Minor Basic Instrument Set',
    image: '/ss/minor-basic-instrument-set.jpg',
    description: 'Core instrument set for minor surgical procedures.',
    items: [
      'Probe with Eye 6″',
      'Knife Handle No 3',
      'Backhaus Towel Clamp 5 1/4″',
      'Backhaus Towel Clamp 3 1/2″',
      'Allis Tissue Forceps 4×5 Teeth 6″',
      'Director and Tongue Tie Probe 6″',
      'Dressing Forceps 5 1/2″ Serrated',
      'Goelet Retractor Double Ended 7 1/2″',
      'Mayo Dissecting Scissors Curved 6 3/4″',
      'Adson Tissue Forceps 4 3/4″ 1×2 Teeth',
      'Rochester Pean Forceps 6 1/4″ Curved',
      'Crile Hemostatic Forceps Curved 5 1/2″',
      'Rochester Ochsner Forceps Straight 6 1/4″',
      'Thumb Tissue Forceps 1×2 Teeth 5 1/2″',
      'Crile Hemostatic Forceps Straight 5 1/2″',
      'Halstead Mosquito Forceps Curved 4 3/4″',
      'Senn Miller Retractor 3 Prongs Blunt 6 1/4″',
      'Weitlaner Retractor 3×4 Teeth 5 1/2″ Blunt',
      'Mayo Dissecting Scissors Straight 6 3/4″',
      'Volkman Retractor 8 1/2″ 3 Prongs Blunt',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Richardson Retractor Hollow Grip Handle 9 1/2″ 1″ X 3/4″',
      'Mayo Hegar Needle Holder Serrated 8″ Tungsten Carbide',
      'Mayo Hegar Needle Holder Serrated 6″ Tungsten Carbide',
      'Metzenbaum Scissors Standard Curved 7″ – Tungsten Carbide',
      'Metzenbaum Scissors Standard Curved 5 1/2″ – Tungsten Carbide',
    ],
  },
 {
    id: 'neurosurgical-laminectomy-instrument-set',
    name: 'Neurosurgical-Laminectomy Instrument Set',
    image: '/ss/neurosurgical-laminectomy-instrument-set.jpg',
    description: 'Comprehensive instrument set for neurosurgical laminectomy procedures.',
    items: [
      'Kelly Hemostatic Forceps 5 1/2″ Curved',
      'Langenbeck Retractor 8″ 1/2″ X 1 1/2″',
      'Langenbeck Retractor 8″ 3/8″ X 1 1/4″',
      'Senn Miller Retractor 3 Prongs Blunt 6 1/4″',
      'Senn Miller Retractor 3 Prongs Sharp 6 1/4″',
      'Crile Wood Needle Holder Tungsten Carbide Jaws Serrated 6″',
      'Webster Needle Holder 4 3/4″ Smooth Jaws – Tungsten Carbide',
      'Backhaus Towel Clamp 5 1/4″',
      'Kocher Forceps 5 1/2″ Straight',
      'Volkman Retractor 8 1/2″ 2 Prongs Sharp',
      'Halstead Mosquito Forceps Curved 4 3/4″',
      'Halstead Mosquito Forceps Straight 4 3/4″',
      'Adson Dressing Forceps 4 3/4″ Serrated',
      'Tissue Forceps 4×5 Teeth 6″',
      'O’Sullivan-O’Connor Abdominal Retractor Complete',
      'Lister Bandage Scissors 5 1/2″',
      'Metzenbaum Scissors Standard Curved 7″ – Tungsten Carbide',
      'Mayo Scissors Tungsten Carbide Curved 5 1/2″',
      'Mayo Scissors Tungsten Carbide Straight 5 1/2″',
      'Lempert Curette 8″ Teardrop Cup Size 4/0',
      'Allis Tissue Forceps 4×5 Teeth 6″',
      'Hoke Osteotome 5 1/2″ Curved 3/8″ (10mm)',
      'Key Elevator 7 1/2” Squared 0.5”',
      'Key Elevator 7 1/2” Squared 0.25”',
      'Sayre Periosteal Elevator 6 3/4″ One Straight Blunt One Curved Sharp End',
      'Adson Elevator 6 3/4” 7mm Semi Sharp Straight',
      'Ruskin Rongeur 7 1/2″ Straight 5mm Double Action',
      'Joseph Double Prong Skin Hook 6″ 2mm Wide',
      'Joseph Hook Sharp Single Prong 6″ 1/2',
      'Knife Handle No 4',
      'Ruskin Rongeur 6″ Straight 3mm Double Action',
      'Lucae Mallet 7 3/4″ 7OZ Convex Flat Head',
      'Ferguson Frazier Suction Tube 9 Fr',
      'Freer Elevator Double Ended With Blunt Sharp Blades 7″ 5mm Wide',
      'Steel Ruler',
      'Weitlaner Retractor 3×4 Teeth 5 1/2″ Blunt',
      'G13-93 Weitlaner Retractor 5 1/2″ 3×4 Sharp Prongs',
      'Hibbs Retractor 9 1/4″ 1″ X 3″ Blade',
      'Volkman Retractor 8 1/2″ 3 Prongs Sharp',
      'Gelpi Retractor 6 1/2″ Standard 16.5cm Sharp Tips',
      'Taylor Spinal Retractor Blade 1 1/4″ x 3″ Size 7 1/4″',
      'Hudson Brace Set, Standard Thumbscrew Chuck',
      'Hudson Cerebellar Extension 4″ For Use With Hudson Braces',
      'Debakey Vascular Tissue Forceps 1.5mm wide Tips 6″',
      'Love Nerve Retractor Straight 7mm Blade Size 8 1/2″',
      'Spratt (brun) Mastoid Curette 6 1/2″ Oval Cups Size 0 (5.8mm)',
      'Spratt (Brun) Mastoid Curette 6 1/2″ Oval Cups Size 2/0 (4.8mm)',
      'G19-158 Spratt (Brun) Mastoid Curette 6 1/2″ Oval Cups Size 4/0 (2.6mm)',
      'G13-254 Beckman Retractor Hinged 4×4 Teeth 12 1/2″ 1 3/4″ x 1 1/4″ Blunt',
      'G46-181 Kerrison Cervical Rongeur Shaft 7″ 40 Forward Angle 2mm',
      'G17-72 Ryder Needle Holder Serrated 8″ Tungsten Carbide',
      'G11-13 Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'G11-54 Adson Hemostatic Forceps Curved 7 1/4″',
      'G11-53 Adson Hemostatic Forceps Straight 7 1/4″',
      'G12-59 Cushing Tissue Forceps 7 1/4″ Bayonet Style 1×2 Teeth',
      'G12-58 Cushing Tissue Forceps 7 1/4″ Bayonet Style Serrated',
      'G12-22 Adson Tissue Forceps 4 3/4″ 1×2 Teeth',
      'G12-21 Adson Dressing Forceps 4 3/4″ Serrated',
      'G46-238 Strully Neurosurgical Scissors 8″ Curved Blade With Probe Tips',
      'G46-318 Meniscus Probe – Dandy Nerve Hook 9″ 1.5x6mm Tip',
      'G08-01 Knife Handle No 3',
      'G22-130 Hoke Osteotome 5 1/2″ Straight 1/2″ (13mm)',
      'G22-127 Hoke Osteotome 5 1/2″ Straight 1/4″ (6mm)',
      'G22-125 Hoke Osteotome 5 1/2″ Straight 1/8″ (3mm)',
      'G46-390 Beckman Eaton Laminectomy Retractor Hinged Sharp 7×7 Teeth 1 3/4″ Wide X 2″ Deep Size 12 3/4″',
      'G46-360 Penfield Dissector Double End Wax Packer and 6mm Blunt Dissector Slightly Curved Size 7 3/4″',
      'G46-356 Adson Elevator 6 3/4” 7mm Semi Sharp Straight',
      'G46-322 Smithwick Nerve Hook Blunt 10mm Deep Size 7″',
      'G46-324 Smithwick Sympathectomy Hook and Dissector Size 12″',
      'G10-308 Potts Smith Scissors Delicate Angled On Side 45° 7″',
      'G46-262 Cushing Spatula Spoon 6 3/4″ Spoon Ends 1/2″ and 3/4″',
      'G46-252 Adson Aneurysm Needle Size 9″',
      'G46-194 Love Gruenwald Rongeur 5″ Down 3x10mm',
      'G46-192 Love Gruenwald Rongeur 5″ Up 3x10mm',
      'G46-190 Love Gruenwald Rongeur 5″ Straight 3x10mm',
      'G46-179 Kerrison Cervical Rongeur Shaft 7″ Down Bite 3mm',
      'G46-176 Kerrison Rongeur 7″ 3mm Up-Bit Thin Foot Plate 40 Degree',
      'G46-183 Kerrison Cervical Rongeur Shaft 7″ 40 Forward Angle 5mm',
      'G46-182 Kerrison Cervical Rongeur Shaft 7″ 40 Forward Angle 3mm',
    ],
  },
 {
    id: 'open-heart-instrument-set',
    name: 'Open Heart Instrument Set',
    image: '/ss/open-heart-instrument-set.jpg',
    description: 'Specialized instrument set for open heart procedures.',
    items: [
      'Richardson Eastman Retractors Double Ended Set Of Two 10″',
      'Backhaus Towel Clamp 5 1/4″',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Mayo Hegar Needle Holder Serrated 7″ Tungsten Carbide',
      'Allis Willauer Tissue Forceps 5X6 Teeth 10″',
      'Tube Occluding Clamps Straight 7 1/4″ Smooth Jaws',
      'Knife Handle No 3',
      'Knife Handle No 4',
      'Knife Handle No 7',
      'Gemini Mixter 9″ Delicate Full Curved Jaws',
      'Metzenbaum Scissors Standard Curved 11″ – Tungsten Carbide',
      'Debakey Needle Holder 7″ Tungsten Carbide Insert',
      'Debakey Thoracic Tissue Forceps 2.5mm wide Tips 7 1/2″',
      'Debakey Multipurpose Clamp Angle 60 – 4cm Jaws Size 9 1/2″',
      'Debakey Multipurpose Clamp Angle 60 – 6.5cm Jaws Size 9 1/2″',
      'Glover Ducts Clamp Straight 8″ 3cm Jaws',
      'Satinsky Debakey Vascular Clamp For Vena Cava Medium Size 9 3/4″',
      'Halstead Mosquito Forceps Straight 4 3/4″',
      'Mayo Scissors Tungsten Carbide Straight 6 3/4″',
      'Mayo Scissors Tungsten Carbide Curved 6 3/4″',
      'Metzenbaum Scissors Standard Curved 5 1/2″ – Tungsten Carbide',
      'Metzenbaum Scissors Delicate Curved 7″ – Tungsten Carbide',
      'Metzenbaum Scissors Standard Curved 8″ – Tungsten Carbide',
      'Adson Tissue Forceps 4 3/4″ 1×2 Teeth',
      'Russian Tissue Forceps 8″',
      'Cushing Forceps 7″ 1×2 Teeth',
      'Yankauer Suction Tube 20 Fr Standard Size',
      'Halstead Mosquito Forceps Curved 4 3/4″',
      'Crile Hemostatic Forceps Curved 5 1/2″',
      'Coller Crile Forceps Curved 6 1/4″',
      'Rochester Pean Forceps 9″ Curved',
      'Rochester Ochsner Forceps Straight 8″',
      'Mixter Hemostatic Forceps Curved 7 1/4″ Fully Serrated',
      'Adson Hemostatic Forceps Curved 7 1/4″',
    ],
  },
 {
    id: 'plastic-surgery-set',
    name: 'Plastic Surgery Set',
    image: '/ss/plastic-set.jpg',
    description: 'Comprehensive instrument set for plastic surgery procedures.',
    items: [
      'Gemini Mixter 5 1/2″ Delicate Full Curved Jaws',
      'Allis Tissue Forceps 4×5 Teeth 6″',
      'Joseph Double Prong Skin Hook 6″ 2mm Wide',
      'Joseph Hook Sharp Single Prong 6″ 1/2',
      'Ferguson Frazier Suction Tube 9 Fr',
      'Weitlaner Retractor 2×3 Teeth 4″Blunt',
      'Senn Miller Retractor 3 Prongs Sharp 6 1/4″',
      'Jansen Mastoid Retractor 3x3th Blunt 3 1/4″',
      'Crile Wood Needle Holder Tungsten Carbide Jaws Smooth 6″',
      'Webster Needle Holder 4 3/4″ Smooth Jaws – Tungsten Carbide',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Backhaus Towel Clamp 5 1/4″',
      'Iris Scissors Straight 4 1/2″ – Sharp Tips',
      'Crile Rankin Hemostatic Forceps Curved 6 1/4″',
      'Kelly Hemostatic Forceps 5 1/2″ Curved',
      'Halstead Mosquito Forceps Curved 4 3/4″',
      'Halstead Mosquito Forceps Straight 4 3/4″',
      'Adson Brown Tissue Forceps 7×7 Teeth Side Grasping 4 3/4″',
      'Adson Tissue Forceps 4 3/4″ 1×2 Teeth',
      'Adson Dressing Forceps 4 3/4″ Serrated',
      'Ragnell Dissecting Scissors Straight 5″',
      'Metzenbaum Dissecting Scissors Curved 5″ Delicate – Lahey',
      'Iris Scissors Curved 4 1/2″ – Sharp Tips',
    ],
  },
 {
    id: 'thyroidectomy-set',
    name: 'Thyroidectomy Set',
    image: '/ss/thyroidectomy-set.jpg',
    description: 'Comprehensive instrument set for thyroidectomy procedures.',
    items: [
      'Crile Wood Needle Holder Tungsten Carbide Jaws Smooth 6″',
      'Allis Tissue Forceps 4×5 Teeth 6″',
      'Lahey Tenaculum Forceps 6″',
      'Cushing Vein and Nerve Retractor 9″',
      'Green Thyroid Retractor 8 1/2″',
      'Lahey Thyroid Retractor 7 1/2″',
      'Lovelace Hemostatic Forceps Straight 6 1/4″ 1×2 Teeth',
      'Metzenbaum Scissors Standard Curved 7″ – Tungsten Carbide',
      'Metzenbaum Scissors Delicate Curved 7″ – Tungsten Carbide',
      'Joseph Double Prong Skin Hook 6″ 2mm Wide',
      'Joseph Hook Sharp Single Prong 6″ 1/2',
      'Ferguson Frazier Suction Tube 9 Fr',
      'Weitlaner Retractor 2×3 Teeth 4″Blunt',
      'Senn Miller Retractor 3 Prongs Sharp 6 1/4″',
      'Jansen Mastoid Retractor 3x3th Blunt 3 1/4″',
      'Iris Scissors Straight 4 1/2″ – Sharp Tips',
      'Webster Needle Holder 4 3/4″ Smooth Jaws – Tungsten Carbide',
      'Foerster Sponge Forceps Straight 9 1/2″ Serrated Jaws',
      'Backhaus Towel Clamp 5 1/4″',
      'Gemini Mixter 5 1/2″ Delicate Full Curved Jaws',
      'Crile Rankin Hemostatic Forceps Curved 6 1/4″',
      'Kelly Hemostatic Forceps 5 1/2″ Curved',
      'Halstead Mosquito Forceps Curved 4 3/4″',
      'Halstead Mosquito Forceps Straight 4 3/4″',
      'Adson Brown Tissue Forceps 7×7 Teeth Side Grasping 4 3/4″',
      'Adson Tissue Forceps 4 3/4″ 1×2 Teeth',
      'Adson Dressing Forceps 4 3/4″ Serrated',
      'Ragnell Dissecting Scissors Straight 5″',
      'Metzenbaum Dissecting Scissors Curved 5″ Delicate – Lahey',
      'Iris Scissors Curved 4 1/2″ – Sharp Tips',
    ],
  },
 ];
 
 export function getSetById(id) {
   return surgicalSets.find((s) => s.id === id);
 }